import Amar from "../../assets/images/teamImages/Amar.png";
import Gayatri from "../../assets/images/teamImages/Gayatri.png";
import Jyotsna from "../../assets/images/teamImages/Jyotsna.png";
import Paresh from "../../assets/images/teamImages/Paresh.png";
// import Parth from "../../assets/images/teamImages/Parth.png";
// import Rushikesh from "../../assets/images/teamImages/Rushikesh.png";
import Finance1 from "../../assets/images/teamImages/Makrand.png";
import Finance2 from "../../assets/images/teamImages/Madhura.png";
// import Partner1 from "../../assets/images/teamImages/Partner1.png";
// import Swapnil from "../../assets/images/teamImages/Swapnil.png";
// import Akshay from "../../assets/images/teamImages/Swapnil.png";
// import Gargi from "../../assets/images/teamImages/Gargi.png";


export const teamMembers = [
  {
    name: "Amarnath Chakradeo",
    role: "CEO, Co-founder",
    // description:" Dummy desc aahe actual pahije Provides clinical guidance to ensure all solutions meet orthopedic standards and patient care requirements.",
    image:Amar,
  },
  {
    name: "Paresh Gokhale",
     role: "CTO, Founding Director",
    // description: " Dummy desc aahe actual pahije Provides clinical guidance to ensure all solutions meet orthopedic standards and patient care requirements.",
    image: Paresh,
  },
   {
    name: "Makarand Karve",
     role: "CFO, Co-founder",
    // description:" Dummy desc aahe actual pahije Provides clinical guidance to ensure all solutions meet orthopedic standards and patient care requirements.",
    image: Finance1,
  },
  {
    name: "Jyotsna Chakradeo",
    role: "Director",
    // description:" Dummy desc aahe actual pahije Provides clinical guidance to ensure all solutions meet orthopedic standards and patient care requirements.",
    image: Jyotsna,
  },
  {
    name: "Madhura Karve",
     role: "Director",
    // description:" Dummy desc aahe actual pahije Provides clinical guidance to ensure all solutions meet orthopedic standards and patient care requirements.",
    image: Finance2,
  },
  {
    name: "Gayatri Chakradeo",
    role: "Creative Partner,Marketting strategies",
    // description:" Dummy desc aahe actual pahije Provides clinical guidance to ensure all solutions meet orthopedic standards and patient care requirements.",
    image: Gayatri,
  },
  // {
  //   name: "Parth Pujari",
  //    role: "Software Developer",
  //   // description:" Dummy desc aahe actual pahije Provides clinical guidance to ensure all solutions meet orthopedic standards and patient care requirements.",
  //   image: Parth,
  // },
  // {
  //   name: "Rushabh Biju",
  //    role: "Software Developer",
  //   // description:" Dummy desc aahe actual pahije Provides clinical guidance to ensure all solutions meet orthopedic standards and patient care requirements.",
  //   image: Rushikesh,
  // },
 
   
  //  {
  //   name: "Shabbir Patheria",
  //   role: "Software Developer",
  //   // description:" Dummy desc aahe actual pahije Provides clinical guidance to ensure all solutions meet orthopedic standards and patient care requirements.",
  //   image: Partner1,
  // },
  // {
  //   name: "Akshay Vispute",
  //   role: "Software Designer",
  //   // description:" Dummy desc aahe actual pahije Provides clinical guidance to ensure all solutions meet orthopedic standards and patient care requirements.",
  //   image: Akshay,
  // },
  // {
  //   name: "Gargi Deo",
  //   role: "Software ",
  //   // description:" Dummy desc aahe actual pahije Provides clinical guidance to ensure all solutions meet orthopedic standards and patient care requirements.",
  //   image: Gargi,
  // },
  //  {
  //   name: "Swapnil Patankar",
  //   role: "Operations",
  //   // description:" Dummy desc aahe actual pahije Provides clinical guidance to ensure all solutions meet orthopedic standards and patient care requirements.",
  //   image: Swapnil,
  // }
];